app.factory('doctorService', ['$q', 'baseService', 'objectHelper', 'config',
    function($q, baseService, objectHelper, config) {

	    function PatientService() {

			this.getById = function(id) {
				var d = $q.defer();

				baseService.get(config.API_URL + '/doctors/' + id).then(
					function(successResponse) {
						var data = objectHelper.translateObject(successResponse, DoctorVO);
						data = objectHelper.convertTimesToDates(data);

						d.resolve(data);
					},
					function(errorResponse) {
						d.reject(errorResponse);
					}
				);

				return d.promise;
			};

			this.getDataPage = function (criteria) {
				return baseService.post(config.API_URL + '/doctors/dataPage', criteria).then(
					function (successResponse) {
						var dataPage = objectHelper.translateObject(successResponse, DataPageVO);
						dataPage.data = objectHelper.translateArray(dataPage.data, DoctorVO);
						dataPage = objectHelper.convertTimesToDates(dataPage);
						return dataPage;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};

			this.save = function (addDoctorRequestWrapper) {
				return baseService.post(config.API_URL + '/doctors', addDoctorRequestWrapper).then(
					function (successResponse) {
						var dataPage =  objectHelper.translateObject(successResponse, DoctorVO);
						dataPage = objectHelper.convertTimesToDates(dataPage);
						return dataPage;
					},
					function (errorResponse) {
						return $q.reject(errorResponse);
					}
				);
			};
	        
	    }
	
	    return new PatientService();
	}
]);
